import React from "react";

import BooleanSelector from "./BooleanSelector";

export default function AllowNullBAhSelector(props) {
  return <BooleanSelector label="Permitir código Ahumada nulo" {...props} />;
}
